module.exports = __webpack_public_path__ + "static/media/banner-1.95b4b8c6.jpeg";